var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"home-slider"},[_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('home-slider')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }